export default {
  首页: "Головна",
  资产: "Активи",
  币币: "Спот",
  快捷买币: "Швидка купівля криптовалюти",
  "支持多种方式购买，购买更简单":
    "Купуйте легко за допомогою кількох способів оплати",
  语言设置: "Налаштування мови",
  确认恢复: "Підтвердити відновлення",
  "输入邮箱，方便我们联系您":
    "Введіть свою електронну адресу, щоб ми могли зв'язатися з вами",
  划转: "Переказ",
  行情: "Ринок",
  "24H成交": "Обсяг за 24 год",
  累计收益: "Загальний дохід",
  充值时间: "Дата поповнення",
  到期时间: "Дата закінчення",
  数量: "Кількість",
  操作: "Дія",
  资产信息: "Інформація про активи",
  复制地址: "Копіювати адресу",
  链名称: "Назва мережі",
  充值地址: "Адреса для поповнення",
  收款地址: "Адреса отримувача",
  账单: "Рахунок",
  提现金额: "Сума для виведення",
  接收地址: "Адреса отримувача",
  交易密码: "Пароль для торгівлі",
  提现全部: "Вивести все",
  保存图片: "Зберегти зображення",
  输入您的交易密码: "Введіть свій пароль для торгівлі",
  确定: "Підтвердити",
  地址: "Адреса",
  注册时间: "Дата реєстрації",
  取消: "Скасувати",
  是否划转: "Переказати?",
  登录: "Увійти",
  我的地址: "Мої адреси",
  登录密码和交易密码: "Пароль входу та пароль для торгівлі",
  注册: "Реєстрація",
  密码: "Пароль",
  设置密码: "Встановити пароль",
  重复密码: "Повторити пароль",
  新密码: "Новий пароль",
  确认新密码: "Підтвердити новий пароль",
  充值: "Поповнити",
  充值货币: "Поповнити валюту",
  合约账户充值: "Поповнити рахунок ф'ючерсів",
  账户充值: "Поповнити рахунок",
  其他: "Інше",
  我的邀请码: "Мій код запрошення",
  提现: "Вивести",
  客服: "Служба підтримки",
  持有详情: "Деталі володіння",
  请输入内容: "Введіть вміст",
  邀请好友来领取奖励: "Запросіть друзів та отримайте винагороди",
  复制链接: "Копіювати посилання",
  重复设置新的密码: "Повторити новий пароль",
  保存: "Зберегти",
  我的: "Мій обліковий запис",
  "邮箱/手机号": "Електронна пошта/Номер телефону",
  备注: "Примітка",
  地址管理: "Управління адресами",
  我的团队: "Моя команда",
  联系我们: "Зв'яжіться з нами",
  竭诚为您服务: "Ми до ваших послуг",
  提取收益: "Вивести дохід",
  带给我的收益: "Згенерований дохід",
  添加: "Додати",
  名称: "Назва",
  添加地址: "Додати адресу",
  修改地址: "Змінити адресу",
  可提现: "Можна вивести",
  安全中心: "Центр безпеки",
  收益划转: "Переказ доходу",
  通知中心: "Сповіщення",
  "累计收益:": "Загальний дохід:",
  注册用户: "Зареєстровані користувачі",
  奖励规则: "Правила винагород",
  帮助反馈: "Допомога та зворотний зв'язок",
  邀请好友: "Запросити друзів",
  恢复身份: "Відновити особу",
  选择语言: "Вибрати мову",
  设置新的密码: "Встановити новий пароль",
  暂无活动: "Немає активних заходів",
  "月增长量(+)": "Місячне зростання (+)",
  可提取: "Можна вивести",
  反馈类型: "Тип зворотного зв'язку",
  赠送: "Подарунок",
  已经复制: "Скопійовано",
  保存成功: "Збережено успішно",
  划转成功: "Переказ успішний",
  过期: "Термін дії минув",
  提交成功: "Успішно надіслано",
  "服务器繁忙，稍后在试": "Сервер зайнятий, спробуйте пізніше",
  全部: "Усі",
  一级: "Рівень 1",
  二级: "Рівень 2",
  三级: "Рівень 3",
  级: "Рівень",
  删除成功: "Успішно видалено",
  选择地址: "Виберіть адресу",
  不再提醒: "Більше не показувати",
  "最小充值金额：": "Мінімальна сума поповнення:",
  选择币种: "Виберіть криптовалюту",
  输入投资金额: "Введіть суму інвестиції",
  输入账户密码: "Введіть пароль облікового запису",
  投资: "Інвестувати",
  订单编号: "Номер замовлення",
  投资周期: "Інвестиційний період",
  投资资金: "Інвестована сума",
  投资时间: "Час інвестиції",
  状态: "Статус",
  投资中: "Активний",
  已到期: "Термін дії минув",
  暂无数据: "Немає даних",
  转入: "Переказати на",
  邮箱: "Електронна пошта",
  请输入邮箱: "Введіть електронну пошту",
  请输入格式正确的邮箱: "Введіть дійсну електронну адресу",
  请输入验证码: "Введіть код підтвердження",
  获取验证码: "Отримати код підтвердження",
  请输入邀请码: "Введіть код запрошення",
  今天: "Сьогодні",
  昨天: "Вчора",
  最近七天: "Останні 7 днів",
  邀请: "Запросити",
  购买数量: "Кількість покупки",
  产品详情: "Деталі продукту",
  币种: "Криптовалюта",
  利息币种: "Валюта доходу",
  理财类型: "Тип фінансового продукту",
  产品费率: "Комісії продукту",
  进行中: "Активний",
  每天: "Щодня",
  请输入搜索关键词: "Введіть ключове слово",
  通知: "Сповіщення",
  查看更多: "Дивитися більше",
  理财宝: "Фінансові продукти",
  周期: "Термін",
  年利率: "Річна відсоткова ставка (APY)",
  更多产品: "Більше продуктів",
  灵活存取: "Гнучкі заощадження",
  稳定收益: "Стабільний дохід",
  合约指南: "Посібник з ф'ючерсів",
  资金划转出: "Вихідний переказ",
  矿池收益: "Винагорода за майнінг",
  提现手续费: "Комісія за виведення",
  冻结资金: "Заморожені кошти",
  解冻资金: "Розмороження заморожених коштів",
  闪兑支出: "Витрата на швидкий обмін",
  闪兑收入: "Дохід від швидкого обміну",
  闪兑手续费: "Комісія за швидкий обмін",
  合约支出: "Витрата на ф'ючерси",
  合约收入: "Дохід від ф'ючерсів",
  输入的金额不可大于可用金额: "Сума не може перевищувати доступну суму",
  全部兑换成功: "Повний обмін успішний",
  返回: "Назад",
  查看历史: "Переглянути історію",
  闪兑历史: "Історія швидкого обміну",
  支付: "Сплатити",
  获取: "Отримати",
  时间: "Час",
  手续费: "Комісія за транзакцію",
  折扣: "Знижка",
  价格: "Ціна",
  逐仓: "Ізольована маржа",
  全仓: "Крос-маржа",
  市价委托: "Ринкове замовлення",
  限价委托: "Лімітне замовлення",
  请输入本金: "Введіть основну суму",
  请输入价格: "Введіть ціну",
  "可做空/做多": "Можливість шорт/лонг",
  设置止盈止损: "Встановити take-profit/stop-loss",
  止盈价: "Ціна take-profit",
  止损价: "Ціна stop-loss",
  成本: "Собівартість",
  做多: "Лонг",
  做空: "Шорт",
  仓位信息: "Інформація про позицію",
  一键平仓: "Закрити позицію (один клік)",
  永续: "Перпетуальний",
  浮动盈亏: "Нереалізований прибуток/збиток",
  平仓: "Закрити позицію",
  反向开仓: "Відкрити зворотну позицію",
  一键撤销: "Скасувати все (один клік)",
  倍杠杆: "x кредитне плече",
  执行价格: "Ціна виконання",
  委托数量: "Кількість замовлення",
  保证金: "Маржа",
  成交价: "Ціна виконання",
  创建时间: "Час створення",
  撤销: "Скасувати",
  合约市场: "Ринок ф'ючерсів",
  交易方向: "Напрямок торгівлі",
  委托价格: "Ціна замовлення",
  委托金额: "Сума замовлення",
  资金费率: "Ставка фінансування",
  "多方和空方交易者支付的定期费用，每8小时结算一次。":
    "Періодична комісія, що сплачується довгими та короткими позиціями, розраховується кожні 8 годин.",
  "资金费率为正，多方向空方支付资金费用。":
    "При позитивній ставці фінансування довгі позиції платять коротким позиціям.",
  "资金费率为负，空方向多方支付资金费用。":
    "При негативній ставці фінансування короткі позиції платять довгим позиціям.",
  "确定反向开仓吗？反向开仓将以当期相反 的仓位进行买入":
    "Ви впевнені, що хочете відкрити зворотну позицію? Це купить протилежний напрямок вашої поточної позиції.",
  "仓位止盈/止损": "Take-profit/Stop-loss для позиції",
  合约名称: "Ф'ючерсний контракт",
  开仓价格: "Ціна відкриття",
  指数价格: "Індексна ціна",
  止盈设置: "Налаштування take-profit",
  请输入止盈价: "Введіть ціну take-profit",
  "当指数价格触达*时，将会触发委托平仓":
    "Коли індексна ціна досягне *, буде активовано замовлення на закриття.",
  预计盈亏: "Очікуваний прибуток/збиток",
  当前仓位: "Поточна позиція",
  平仓金额: "Сума закриття",
  仓位模式: "Режим позиції",
  全仓模式: "Режим крос-маржа",
  "合约账户中的所有可用资金视作为可用保证金， 当仓位亏损超过了账户余额才会爆仓强平，并将损失所有 保证金和仓位，请注意":
    "У режимі крос-маржа всі доступні кошти на вашому рахунку ф'ючерсів використовуються як маржа. Ліквідація відбувається, коли збиток перевищує ваш загальний баланс, що призводить до втрати всієї вашої маржі та позиції.",
  逐仓模式: "Режим ізольованої маржі",
  "会使合约账户中的一定数量保证金被分配到仓位上。如果保证金亏损低于维持保证金的水平，仓位被强平。在逐仓模式下，您可以为这个仓位增加和减少保证金。":
    "Певна сума маржі виділяється на позицію. Якщо збиток маржі падає нижче рівня підтримувальної маржі, позиція ліквідується. У режимі ізольованої маржі ви можете збільшувати або зменшувати маржу для цієї позиції.",
  "是否撤销？": "Скасувати замовлення?",
  "是否一键撤销？": "Скасувати всі замовлення?",
  "是否一键平仓？": "Закрити всі позиції?",
  持仓保证金: "Маржа поточної позиції",
  风险率: "Коефіцієнт ризику",
  未实现盈亏: "Нереалізований прибуток/збиток",
  可用保证金: "Доступна маржа",
  净值: "Чиста вартість",
  账户余额: "Баланс рахунку",
  合约计算器: "Калькулятор ф'ючерсів",
  交易记录: "Історія транзакцій",
  "*倍杠杆": "*x кредитне плече",
  "平仓盈亏：": "Реалізований прибуток/збиток:",
  时间筛选: "Фільтр часу",
  仓位类型: "Тип позиції",
  订单状态: "Статус замовлення",
  订单类型: "Тип замовлення",
  平仓价格: "Ціна закриття",
  持仓数量: "Кількість позиції",
  "手续费(%)": "Комісія за транзакцію (%)",
  平仓时间: "Час закриття",
  平仓类型: "Тип закриття",
  手动平仓: "Ручне закриття",
  强制平仓: "Примусова ліквідація",
  近1天: "Останній день",
  近7天: "Останні 7 днів",
  近30天: "Останні 30 днів",
  近180天: "Останні 180 днів",
  持仓: "Відкрита позиція",
  已取消: "Скасовано",
  分时: "Внутрішньоденний",
  "24H额(USDT)": "Обсяг за 24 год (USDT)",
  "24H低": "24 год мінімум",
  "24H量(BTC)": "Обсяг за 24 год (BTC)",
  "24H高": "24 год максимум",
  "10秒": "10 секунд",
  "30秒": "30 секунд",
  "1分": "1 хвилина",
  "3分": "3 хвилини",
  "5分": "5 хвилин",
  "30分": "30 хвилин",
  "1小时": "1 година",
  "4小时": "4 години",
  "8小时": "8 годин",
  "1天": "1 день",
  "1周": "1 тиждень",
  "1月": "1 місяць",
  单向持仓: "Односпрямована позиція",
  杠杆: "Кредитне плече",
  仓位: "Позиція",
  计算结果: "Результат",
  盈亏: "Прибуток/Збиток",
  收益率: "Прибутковість",
  计算结果仅供参考: "Результат є орієнтовним",
  成交后仓位大小: "Розмір позиції після виконання",
  "计算结果仅供参考,实际结果可能因费率差异":
    "Результат є орієнтовним, фактичні результати можуть відрізнятися через комісії.",
  目标价格: "Цільова ціна",
  开始计算: "Розрахувати",
  强平价格: "Ціна ліквідації",
  "充值前，请认真核对充值的链名称，充值错误无法找回资产*最小充值金额为*；少于此金额平台将无法确认到账，请不要向此地址充值*之外的资产，否则将无法找回资产，请不要直接提现众筹或者ICO地址，平台不会代理币的发放。":
    "Перед поповненням уважно перевірте назву мережі. Помилкові поповнення не можна скасувати. Мінімальна сума поповнення становить *. Поповнення на суму менше цієї суми не будуть оброблені. Не надсилайте інші активи на цю адресу. Не використовуйте ICO або краудфандингові адреси для виведення.",
  "最小输入*": "Мінімум {0}",
  "最小提币数量为*，提币手续费将从你的提款金额中扣除。提币前请确认核对收款地址，不要将*提现至*以外的地址，否则无法找回资产。请不要直接提现众筹或者ICO地址，平台不会处理代币的发放。":
    "Мінімальна кількість для виведення становить *. Комісії за виведення будуть відраховані з суми виведення. Уважно перевірте адресу отримувача. Не надсилайте * на адреси за межами *. Не використовуйте ICO або краудфандингові адреси.",
  退出登录: "Вийти",
  加仓: "Збільшити позицію",
  新增仓位: "Нова позиція",
  输入加仓金额: "Введіть суму для збільшення позиції",
  "当前可用:": "Зараз доступно:",
  资产账单: "Рахунок активів",
  保存二维码: "Зберегти QR-код",
  温馨提示: "Примітка",
  "请注意：您当前使用的网络": "Примітка: Ви зараз використовуєте мережу",
  输入提现地址: "Введіть адресу для виведення",
  "可用金额：": "Доступна сума:",
  输入资产密码: "Введіть пароль активів",
  可用手续费: "Доступна комісія",
  "折扣%": "Знижка %",
  实扣手续费: "Фактично нарахована комісія",
  实际到账: "Фактично отримана сума",
  未设置资产密码: "Пароль активів не встановлено",
  "为了您的资产安全，请设置资产密码后再来提现。":
    "Для вашої безпеки встановіть пароль активів перед виведенням коштів.",
  热榜: "Популярне",
  涨幅榜: "Найбільші зростання",
  跌幅榜: "Найбільші падіння",
  成交额榜: "Рейтинг обсягу",
  关于我们: "Про нас",
  登录密码: "Пароль входу",
  设置: "Налаштування",
  资产密码: "Пароль активів",
  修改登录密码: "Змінити пароль входу",
  原密码: "Старий пароль",
  请输入新密码: "Введіть новий пароль",
  请输入原密码: "Введіть старий пароль",
  确认密码: "Підтвердити пароль",
  确定修改: "Підтвердити зміну",
  修改资产密码: "Змінити пароль активів",
  验证码: "Код підтвердження",
  资产密码使用提示: "Поради щодо пароля активів",
  "资产密码用于转移、提取资产和交易。":
    "Пароль активів використовується для переказу, виведення та торгівлі активами.",
  "创建与登录密码不同的资产密码。":
    "Створіть пароль активів, відмінний від пароля входу.",
  "定期更改您的资产密码。": "Регулярно змінюйте свій пароль активів.",
  提币历史: "Історія виведень",
  "金额/余额": "Сума/Баланс",
  "手续费/折扣": "Комісія/Знижка",
  自选: "Обрані",
  现货: "Спот",
  市价: "Ринкова ціна",
  止损设置: "Налаштування stop-loss",
  合约K线图: "Графік ф'ючерсів",
  "24H量": "Обсяг за 24 год",
  "24H额": "Обсяг за 24 год (USDT)",
  合作指南: "Путівник для партнера",
  盈亏计算: "Розрахунок прибутку/збитку",
  当前可用: "Зараз доступно",
  请输入加仓金额: "Введіть суму для збільшення позиції",
  请重新输入加仓金额: "Введіть повторно суму для збільшення позиції",
  平仓数量: "Кількість для закриття",
  欢迎登录: "Ласкаво просимо назад",
  "忘记密码?": "Забули пароль?",
  "还没有账号？": "Ще немає облікового запису?",
  立即注册: "Зареєструватися зараз",
  繁體中文: "Традиційна китайська",
  找回密码: "Відновити пароль",
  下一步: "Далі",
  注册账户: "Зареєструвати обліковий запис",
  "请输入邀请码(选填)": "Введіть код запрошення (необов'язково)",
  谢邀豪礼: "Бонус за запрошення",
  "24小时邀请好友排名": "24-годинний рейтинг запрошень",
  "*人": "* осіб",
  "差*人": "Бракує * осіб",
  "已超过10万人，每月轻松赚钱":
    "Понад 100 000 користувачів, заробляйте легко щомісяця",
  最高: "Максимум",
  邀请链接: "Посилання для запрошення",
  "平台和您共享好友在平台（现货、合约、杠杆、闪兑）所产生的手续费":
    "Діліться комісіями за транзакції, згенерованими вашими друзями (спот, ф'ючерси, кредитне плече, швидкий обмін).",
  平台和您一起分享手续费: "Діліться комісіями за транзакції з платформою",
  "*级": "* рівень",
  规则: "Правила",
  我的好友: "Мої друзі",
  好友详情: "Деталі друга",
  获得好友佣金方案: "План комісійних від друзів",
  我的等级: "Мій рівень",
  我的邀请数据: "Мої дані запрошень",
  当前等级: "Поточний рівень",
  平台奖励您: "Винагорода платформи для вас",
  最高可获取平台奖励: "Максимальна винагорода платформи",
  邀请规则: "Правила запрошення",
  "邀请*级有效好友": "Запросіть активних друзів рівня *",
  好友等级: "Рівень друга",
  人: "осіб",
  奖金派送: "Виплата бонусу",
  平台奖励: "Винагорода платформи",
  "最终解释权归平台所有，若发现异常获取平台奖励，将会扣除所有的奖励，并且冻结账户，资产的损失将无法找回。":
    "Платформа залишає за собою право остаточного тлумачення. У разі шахрайських дій винагороди будуть скасовані, а ваш обліковий запис буде заморожено. Втрачені активи не можуть бути відновлені.",
  "您的账户必须是有效账户，平台判定有效账户条件为（账户充值任何币种）最小* USDT的价值。":
    "Ваш обліковий запис має бути активним, що визначається як поповнення вартістю щонайменше * USDT у будь-якій криптовалюті.",
  "您邀请的好友，必须是有效下级，平台判定有效下级为（账户充值任何币种）最小* USDT的价值。":
    "Ваш запрошений друг має бути активним нижчим рівнем, що визначається як поповнення вартістю щонайменше * USDT.",
  "邀请人和被邀请者的账号不能同属于一个IP。":
    "Запрошувач та запрошений не можуть мати однакову IP-адресу.",
  "VIP等级由您邀请的*级好友的人数作为考核。":
    "VIP рівень визначається кількістю запрошених друзів рівня *.",
  佣金成分: "Компоненти комісійних",
  收益统计: "Статистика доходу",
  昨日收益: "Вчорашній дохід",
  月收益: "Місячний дохід",
  获取收益: "Отримати дохід",
  "总收益：": "Загальний дохід:",
  "*级好友": "Друзі рівня *",
  理财购买: "Купівля фінансового продукту",
  期限: "Термін",
  可用金额: "Доступна сума",
  预估收益: "Орієнтовний дохід",
  申购上限: "Максимальна купівля",
  项目剩余: "Залишок проекту",
  "买入后预计*(SGT)开始计算收益。":
    "Дохід почне нараховуватися приблизно о *(SGT) після покупки.",
  计息日: "Початок нарахування відсотків",
  申购日: "Дата покупки",
  到账日: "Дата зарахування",
  到期自动续投: "Автоматичне реінвестування після закінчення терміну",
  申购: "Купити",
  搜索理财项目: "Пошук фінансового продукту",
  超高年化随心选: "Виберіть серед продуктів з високою прибутковістю",
  "自由选择理财币种，稳定超额收益":
    "Вільно вибирайте свою криптовалюту для стабільного, вище середнього доходу",
  理财总资产: "Загальні інвестовані активи",
  申购数量: "Кількість для купівлі",
  立即购买: "Купити зараз",
  年化收益率: "Річна процентна дохідність (APY)",
  理财订单: "Замовлення фінансових продуктів",
  持有: "У володінні",
  申购份额: "Куплена частка",
  到账日期: "Дата зарахування",
  申购成功: "Успішна покупка",
  到期: "Термін дії минув",
  是否选择做多: "Відкрити довгу позицію?",
  "可用余额为0 不能操作": "Баланс дорівнює 0, дія неможлива",
  福利中心: "Центр бонусів",
  奖励记录: "Історія винагород",
  我获取到的奖励: "Мої отримані винагороди",
  总价值: "Загальна вартість",
  新手任务: "Завдання для нових користувачів",
  身份认证: "Підтвердження особи (KYC)",
  身份验证: "Підтвердження особи",
  去验证: "Підтвердити зараз",
  审核中: "В очікуванні",
  已验证: "Підтверджено",
  认证失败: "Підтвердження не вдалося",
  基础认证: "Базове підтвердження",
  "请注意认证信息一经验证不能修改，务必填写准确信息":
    "Примітка: Підтверджену інформацію не можна змінити. Введіть точні дані.",
  "国家/地区": "Країна/Регіон",
  请选择: "Виберіть",
  证件类型: "Тип документа",
  证件编码: "Номер документа",
  身份证: "Посвідчення особи",
  护照: "Загранпаспорт",
  驾驶证: "Посвідчення водія",
  请输入编码: "Введіть номер",
  名字: "Ім'я",
  请输入: "Введіть",
  中间名: "По батькові",
  选填: "Необов'язково",
  姓氏: "Прізвище",
  中国: "Китай",
  身份上传: "Завантажити документ, що посвідчує особу",
  上传身份证: "Завантажити посвідчення особи",
  "以上材料需要用JPG/JPEG/PNG格式上传，并且保证照片的清晰边角完整，亮度均匀。且大小不超过*M。":
    "Завантажте у форматі JPG/JPEG/PNG. Переконайтеся, що зображення чіткі, повні та рівномірно освітлені. Максимум *MB.",
  确定提交: "Надіслати",
  去认证: "Підтвердити",
  挑战任务: "Завдання-виклики",
  注册认证任务: "Завдання реєстрації та підтвердження",
  完成注册认证即可领取: "Завершіть реєстрацію та підтвердження, щоб отримати",
  领取奖励: "Отримати винагороду",
  新人豪礼: "Вітальний бонус",
  "参与人数：": "Кількість учасників:",
  条件: "Умова",
  入金量: "Сума поповнення",
  完成: "Завершено",
  任务奖励: "Винагорода за завдання",
  距任务更新: "До оновлення завдання",
  "条件：": "Умова:",
  活动规则: "Правила заходу",
  奖励明细: "Деталі винагороди",
  已获得: "Отримано",
  交易奖励: "Винагорода за торгівлю",
  Win奖励: "WIN винагорода",
  已领取: "Отримано",
  亏损金额超过: "Сума збитку перевищує",
  单笔开仓金额超过: "Сума окремого замовлення перевищує",
  交易量: "Обсяг торгів",
  待完成: "Очікує",
  入金: "Поповнення",
  盈利金额超过: "Сума прибутку перевищує",
  开仓金额: "Сума замовлення",
  开仓金: "Сума замовлення",
  盈利: "Прибуток",
  亏损: "Збиток",
  领取: "Отримати",
  未领取: "Не отримано",
  待领取: "Очікує отримання",
  再交易: "Торгуйте далі",
  即可获得: "щоб отримати",
  领取成功: "Успішно отримано",
  "1、所有的活动都会按照活动最后的时间进行统计收益过期后将无效。":
    "1. Усі заходи будуть розраховані на дату закінчення. Після цього винагороди втрачають чинність.",
  "2、获得的收益会发放到您的赏金账户中，你可以随时根据您的需要进行兑换和提现。":
    "2. Отриманий дохід буде зараховано на ваш бонусний рахунок, який ви можете обміняти або вивести в будь-який час.",
  "3、获取的到的奖励币种类型根据任务按类型发放。":
    "3. Криптовалюта винагороди залежить від завдання.",
  "4、最终解释权归平台所有，若发现存在异常手段套利平台的任务奖金，平台有权冻结并且清除您获取的收益。":
    "4. Платформа залишає за собою право остаточного тлумачення. У разі шахрайства із завданнями винагороди будуть утримані, а ваш обліковий запис може бути заморожено.",
  成长学院: "Академія",
  "区块链 & 加密货币": "Блокчейн та криптовалюта",
  "您的加密货币一站式指南，我们带您开启加密货币之路。":
    "Ваш повний путівник по криптовалюті. Ми супроводжуємо вас у вашій криптоподорожі.",
  "全仓合约定单的全部保证金。":
    "Загальна маржа для замовлень ф'ючерсів з крос-маржею.",
  "(账户余额+(浮动盈亏-手续费-过夜费)=净值/已用保证金*100":
    "(Баланс + (нереалізований прибуток/збиток - комісії - відсотки фінансування) = Чиста вартість / Використана маржа * 100",
  "浮动盈亏会直接影响”可用保证金“，当未实现盈亏增加，可用保证金将会增加，未实现盈亏减少，可用保证金同样也会减少。":
    "Нереалізований прибуток/збиток безпосередньо впливає на 'доступну маржу'. Якщо нереалізований прибуток/збиток зростає, доступна маржа зростає, і навпаки.",
  "账户余额-(已用保证金)+(浮动盈亏-手续费-过夜费)":
    "Баланс - (Використана маржа) + (нереалізований прибуток/збиток - комісії - відсотки фінансування)",
  "注:可继续用于开仓的保证金。":
    "Примітка: Маржа, доступна для відкриття нових позицій.",
  "账户余额+(浮动盈亏-手续费-过夜费)":
    "Баланс + (нереалізований прибуток/збиток - комісії - відсотки фінансування)",
  "注:当前的资金结余。": "Примітка: Поточний баланс.",
  "指的是合约账户的全部余额，包含不可用余额。":
    "Відноситься до загального балансу рахунку ф'ючерсів, включаючи заморожені суми.",
  "注:风险率越高，风险越低，风险率越低，风险越高。":
    "Примітка: Чим вищий коефіцієнт ризику, тим нижчий ризик, і навпаки.",
  该功能尚未开发: "Ця функція ще в розробці",
  重置密码: "Скинути пароль",
  "请输入为8-20位，必须包含字母、数字和特殊字符":
    "Введіть 8-20 символів, включаючи літери, цифри та спеціальні символи",
  修改成功: "Зміна успішна",
  输入验证码: "Введіть код підтвердження",
  输入密码: "Введіть пароль",
  详情说明: "Деталі",
  已售罄: "Розпродано",
  剩余期限: "Залишилося терміну",
  限期: "Термін",
  闪兑货币选择: "Вибір валюти для швидкого обміну",
  地区选择: "Вибір регіону",
  "搜索国家/地区": "Пошук країни/регіону",
  "身份信息已提交，将在*小时内审核完成":
    "Інформацію про особу надіслано. Обробка триватиме до * годин.",
  "选择国家/地区": "Виберіть країну/регіон",
  "止盈价格需高于*": "Ціна take-profit має бути вищою за *",
  "止损价格需低于*": "Ціна stop-loss має бути нижчою за *",
  "止盈价格需低于*": "Ціна take-profit має бути нижчою за *",
  "止损价格需高于*": "Ціна stop-loss має бути вищою за *",
  教程详情: "Деталі підручника",
  请输入止损价: "Введіть ціну stop-loss",
  活期: "Гнучкий",
  赎回后立即到账: "Негайне зарахування після викупу",
  赎回: "Викуп",
  赎回理财: "Викуп фінансового продукту",
  是否赎回当前的理财订单: "Викупити поточне замовлення фінансового продукту?",
  维护: "Технічне обслуговування",
  "系统正在维护中……": "Система на технічному обслуговуванні...",
  合约: "Ф'ючерси",
  闪电兑换: "Швидкий обмін",
  流水挖矿: "Майнінг обсягу",
  邀请豪礼: "Бонус за запрошення",
  计算器: "Калькулятор",
  最新价: "Остання ціна",
  涨跌幅: "Зміна (24 год)",
  关注币种添加自选: "Додати криптовалюту до обраних",
  一键添加自选: "Додати до обраних (один клік)",
  全标已读: "Позначити всі як прочитані",
  无消息: "Немає повідомлень",
  "暂时还没有收到任何消息通知哦!": "Ви ще не отримали жодних сповіщень!",
  没有更多数据: "Немає більше даних",
  闪兑: "Швидкий обмін",
  从: "З",
  "可用余额：": "Доступний баланс:",
  至: "До",
  预览兑换结果: "Попередній перегляд результату обміну",
  闪兑规则: "Правила швидкого обміну",
  "市场闪兑可能变动，请以实际到账的金额数量为准。":
    "Швидкий обмін підлягає ринковим коливанням. Фактично отримана сума є обов'язковою.",
  "对汇兑率由第三方制定，由于兑换成本以及市场波动，您兑换的汇率可能会高于市场的汇率，请仔细确认后进行操作。":
    "Курси обміну встановлюються третьою стороною. Через витрати та коливання курс може відрізнятися від ринкового курсу. Уважно перевірте.",
  "平台对每笔汇兑收取大约*%的手续费，用于支付在交易所兑换成本。":
    "Платформа стягує приблизно *% комісії за обмін для покриття витрат на біржах.",
  确认汇兑: "Підтвердити обмін",
  您预估得到: "Орієнтовне отримання",
  汇兑: "Обмін",
  汇兑比例: "Курс обміну",
  刷新: "Оновити",
  兑换: "Обміняти",
  没有更多了: "Немає більше даних",
  搜索币种: "Пошук криптовалюти",
  可用: "Доступно",
  我知道了: "Я зрозумів",
  最新价格: "Остання ціна",
  确认: "Підтвердити",
  最大: "Максимум",
  "风险率(%)": "Коефіцієнт ризику (%)",
  当前委托: "Поточні замовлення",
  合作交易历史记录: "Історія транзакцій партнера",
  重置: "Скинути",
  余额: "Баланс",
  现货账户: "Спот рахунок",
  合约账户: "Рахунок ф'ючерсів",
  WIN账户: "WIN рахунок",
  赏金账户: "Бонусний рахунок",
  总资产折合: "Загальні активи (в USDT)",
  今日收益: "Сьогоднішній дохід",
  充币: "Поповнення",
  提币: "Виведення",
  账户权益: "Вартість рахунку",
  "数量/类别": "Кількість/Категорія",
  全部币种: "Усі криптовалюти",
  全部类型: "Усі типи",
  账单信息: "Інформація про рахунок",
  理财赎回: "Викуп фінансового продукту",
  购买理财: "Купівля фінансового продукту",
  收入: "Доходи",
  支出: "Витрати",
  到: "на",
  资产划转: "Переказ активів",
  "最少*": "Мінімум *",
  "可用资产：": "Доступні активи:",
  确认划转: "Підтвердити переказ",
  "只有将资产划转至对于的账户才可以进行交易，账户间的划转不收取手续费。":
    "Ви повинні переказати активи на відповідний рахунок, щоб мати можливість торгувати. Перекази між рахунками безкоштовні.",
  币种账户选择: "Вибір рахунку криптовалюти",
  选择账户: "Виберіть рахунок",
  划转详情: "Деталі переказу",
  划转明细: "Специфікація переказу",
  收入账单: "Рахунок доходів",
  支出账单: "Рахунок витрат",
  金额: "Сума",
  总收益: "Загальний дохід",
  佣金: "Комісійні",
  用户名: "Ім'я користувача",
  "已领取：": "Отримано:",
  "未领取：": "Не отримано:",
  "请选择国家/地区": "Виберіть країну/регіон",
  请上传身份信息: "Завантажте інформацію про особу",
  请选择证件类型: "Виберіть тип документа",
  请填写证件编码: "Введіть номер документа",
  请填写名字: "Введіть ім'я",
  请填写姓氏: "Введіть прізвище",
  投资金额: "Сума інвестиції",
  天: "днів",
  请输入手机号: "Введіть номер телефону",
  搜索: "Пошук",
  搜索历史: "Історія пошуку",
  热门推荐: "Популярні рекомендації",
  "《Xspace Earn协议》": "Протокол Xspace Earn",
  我已了解并同意: "Я розумію та погоджуюся",
  协议: "Протокол",
  Xspace官方中文交流群: "Офіційна китайська спільнота Xspace",
  Xspace官方英文交流群: "Офіційна англійська спільнота Xspace",
  预计维护至: "Очікуване техобслуговування до",
  更多功能: "Більше функцій",
  下载APP: "Завантажити додаток",
  理财: "Фінансовий продукт",
  推荐: "Рекомендовано",
  Telegram官方中文频道: "Офіційний Telegram-канал (китайська)",
  Telegram官方英文频道: "Офіційний Telegram-канал (англійська)",
  官方邮箱: "Офіційна електронна пошта",
  客服邮箱: "Електронна пошта служби підтримки",
  上述信息最终解释权归官方所有:
    "Вищезазначена інформація підлягає офіційному тлумаченню платформи.",
  IOS版下载: "Завантажити для iOS",
  Android版下载: "Завантажити для Android",
  "手续费=买入手续费+资金费率+卖出手续费":
    "Комісія за транзакцію = Комісія за купівлю + Ставка фінансування + Комісія за продаж",
  资金划转: "Переказ коштів",
  止盈: "Take-profit",
  止损: "Stop-loss",
  自动平仓: "Автоматичне закриття",
  委托挂单: "Відкрите замовлення",
  买: "Купити",
  卖: "Продати",
  "买入/做多": "Купити/Лонг",
  "卖出/做空": "Продати/Шорт",
  详情: "Деталі",
  浮动涨跌: "Нереалізований прибуток/збиток",
  最小: "Мінімум",
  充币数量: "Кількість поповнення",
  请输入充币数量: "Введіть кількість для поповнення",
  支付截图: "Підтвердження платежу",
  提交: "Надіслати",
  上传驾驶证: "Завантажити посвідчення водія",
  上传护照: "Завантажити паспорт",
  加载中: "Завантаження...",
  上传成功: "Завантаження успішне",
  充值历史: "Історія поповнень",
  合约卖出手续费: "Комісія за продаж ф'ючерсів",
  合约买入手续费: "Комісія за купівлю ф'ючерсів",
  系统加款: "Системне зарахування",
  系统减款: "Системне списання",
  合约资金费率: "Ставка фінансування ф'ючерсів",
  佣金分成: "Розподіл комісійних",
  U本位合约: "Ф'ючерси з маржею в USDT",
  资产管理: "Управління активами",
  APP下载: "Завантажити додаток",
  全球领先的数字理财平台:
    "Світова лідерська платформа цифрового управління багатством",
  "即刻交易比特币、以太坊等上百种数字资产":
    "Торгуйте негайно Bitcoin, Ethereum та сотнями інших цифрових активів",
  "24H涨跌幅": "24-годинна зміна",
  查看更多行情: "Переглянути більше ринків",
  近24小时成交量: "Обсяг за 24 год",
  "提供数百种币币和合约交易对，以满足多样化的交易需求。 平台在200个国家和地区中有超过2千万用户，是全球领先的数字资产服务平台。":
    "Пропонує сотні спотових та ф'ючерсних пар. Понад 20 мільйонів користувачів у більш ніж 200 країнах. Світова лідерська платформа послуг цифрових активів.",
  用户国家分布: "Користувачі за країнами",
  用户数: "Кількість користувачів",
  交易对: "Торгові пари",
  服务支持: "Підтримка",
  "随时随地，多平台终端交易":
    "Торгуйте будь-де за допомогою багатоплатформної підтримки",
  "多终端完美兼容，随时满足各种场景的交易需求。":
    "Сумісний з багатьма пристроями для всіх потреб торгівлі.",
  随时查看实时行情: "Переглядайте ціни в реальному часі будь-де",
  "轻松买卖BTC，ETH，DOGE和其他数字资产":
    "Легко купуйте та продавайте BTC, ETH, DOGE та інші цифрові активи",
  获取您关注的加密货币价格变化预警:
    "Отримуйте сповіщення про ціни на криптовалюти, за якими ви стежите",
  "查看比特币现货、期货、期权价格":
    "Перегляньте ціни на спот, ф'ючерси та опціони Bitcoin",
  比较各交易所加密货币价格: "Порівняйте ціни на криптовалюти на різних біржах",
  开启您的数字货币之旅: "Почніть свою подорож з цифровими активами",
  快捷购买数字货币: "Швидко купуйте криптовалюти",
  "使用多种支付方式交易数字货币，安全快捷":
    "Торгуйте безпечно та швидко за допомогою кількох способів оплати",
  最优的交易费率: "Найкращі комісії за транзакції",
  "优惠的交易费率，富有竞争力的VIP权益，享受最优品质的服务":
    "Вигідні ставки, конкурентні VIP-переваги та послуги найвищої якості.",
  可信赖的安全保障: "Надійна безпека",
  "我们复杂的安全措施和SAFU基金保护您的数字资产免受所有风险。":
    "Розширені заходи безпеки та фонд SAFU захищають ваші активи від ризиків.",
  交易: "Торгівля",
  币币市场: "Спотовий ринок",
  "24H成交量": "Обсяг за 24 год",
  交易所: "Біржа",
  "24H最高": "24-годинний максимум",
  "24H最低": "24-годинний мінімум",
  永续合约: "Перпетуальні ф'ючерси",
  日涨跌: "Денна зміна",
  交易深度: "Глибина книги замовлень",
  "资产(合约)": "Активи (Ф'ючерси)",
  历史仓位: "Історія позицій",
  兑换记录: "Історія обмінів",
  类型: "Тип",
  充值记录: "Історія поповнень",
  划转记录: "Історія переказів",
  类别: "Категорія",
  历史账单: "Історія рахунків",
  在线充值: "Онлайн поповнення",
  安全设置: "Налаштування безпеки",
  用于账户登录使用: "Використовується для входу в обліковий запис",
  用户提现时安全验证使用:
    "Використовується для перевірки безпеки під час виведення",
  验证: "Підтвердити",
  万: "мільйон",
  随时随地开启交易: "Почніть торгівлю будь-де",
  "*货币交易所的所有功能尽在你的手中。":
    "Усі функції * криптобіржі у ваших руках.",
  "下载*货币交易所APP。": "Завантажте додаток * криптобіржі.",
  下载自: "Завантажити з",
  内测版: "Бета-версія",
  下载: "Завантажити",
  扫码下载: "Відскануйте для завантаження",
  设置您的资产密码: "Встановіть свій пароль активів",
  法币: "Фіат",
  我要买: "Я хочу купити",
  我要卖: "Я хочу продати",
  请输入金额: "Введіть суму",
  汇率: "Курс обміну",
  获得: "Отримати",
  支付通道: "Платіжний канал",
  收款通道: "Канал отримання",
  "出售过程需要务必确认好您的收款方式为本人。":
    "Під час продажу переконайтеся, що канал отримання зареєстрований на ваше ім'я.",
  当前法币暂不支持交易对可尝试前往提现:
    "Ця фіатна пара наразі не підтримується. Спробуйте виведення.",
  前往提现: "Перейти до виведення",
  该法币暂无通道: "Немає доступного каналу для цієї фіатної валюти",
  "正在出售中，请耐心等待": "Продаж триває, будь ласка, зачекайте",
  请选择支付通道: "Виберіть платіжний канал",
  请选择方式: "Виберіть спосіб",
  法币历史: "Фіатна історія",
  买币: "Купити криптовалюту",
  卖币: "Продати криптовалюту",
  失败: "Невдало",
  已完成: "Завершено",
  未付款: "Не сплачено",
  待审核: "В очікуванні",
  打款中: "Виплата триває",
  订单详情: "Деталі замовлення",
  联系客服: "Зв'язатися з підтримкою",
  到账金额: "Отримана сума",
  通道: "Канал",
  收款人: "Отримувач",
  收款账户: "Рахунок отримувача",
  "订单出售失败，请查下方失败原因":
    "Продаж замовлення не вдався. Перегляньте причину нижче.",
  失败原因: "Причина невдачі",
  您还未进行付款: "Ви ще не сплатили",
  您已成功购买: "Покупка успішна",
  已取消订单: "Замовлення скасовано",
  "订单正在审核中，请耐心等待":
    "Замовлення обробляється. Будь ласка, зачекайте.",
  您已成功出售: "Продаж успішний",
  "订单正在打款中，请耐心等待": "Виплата триває. Будь ласка, зачекайте.",
  "支付过程需要您前往其他的平台进行支付订单，请注意信息安全。":
    "Для оплати вам потрібно перейти на іншу платформу. Зверніть увагу на безпеку вашої інформації.",
  当前法币暂不支持交易对可尝试前往充值:
    "Ця фіатна пара наразі не підтримується. Спробуйте поповнення.",
  前往充值: "Перейти до поповнення",
  购买: "Купити",
  订单号: "Номер замовлення",
  单价: "Ціна за одиницю",
  到账数量: "Отримана кількість",
  "当前存在未付的订单，是否继续发起新的支付订单？":
    "Існує неоплачене замовлення. Ви хочете ініціювати нове платіжне замовлення?",
  继续支付: "Продовжити оплату",
  重新下单: "Нове замовлення",
  是否确定出售: "Ви впевнені, що хочете продати?",
  "确定出售后，平台将分配给买家，请耐心等待平台的撮合。":
    "Після підтвердження платформа призначить покупця. Зачекайте на співставлення.",
  出售: "Продати",
  收款方式: "Спосіб отримання",
  订单已生成: "Замовлення створено",
  取消订单: "Скасувати замовлення",
  请在: "Будь ласка, протягом",
  内完成付款: "завершіть оплату",
  "离开平台，登录您指定的支付，转账到卖家的以下账户，并务必在付款中备注：":
    "Залиште платформу, увійдіть у вибраний спосіб оплати та перекажіть суму на наступний рахунок продавця. Обов'язково вкажіть посилання:",
  "若付款时未进行备注，卖家将无法确认收款，造成资产损失无法找回。":
    "Без посилання продавець не зможе підтвердити платіж, що може призвести до втрати активів.",
  "未在规定的时间内付款，订单都将被取消。":
    "Якщо ви не сплатите протягом встановленого часу, замовлення буде скасовано.",
  姓名: "Ім'я та прізвище",
  收款姓名: "Ім'я отримувача",
  开户支行: "Відділення банку",
  银行卡号: "Номер банківської картки",
  "付款后，返回本平台": "Після оплати поверніться на цю платформу",
  "请务必点击下方“我已完成付款，通知卖家”按钮":
    "Обов'язково натисніть кнопку 'Я завершив оплату, повідомити продавця'",
  未点击卖家不会放款:
    "Продавець випустить криптовалюту лише після того, як ви натиснете кнопку",
  交易条款: "Умови транзакції",
  "购买资金来源，必须合法安全的资金，方可交易":
    "Кошти для покупки повинні бути законними та безпечними",
  "不允许诈骗、传销、赌博或者其他非法资金交易":
    "Шахрайство, піраміди, азартні ігри або інші незаконні кошти не дозволяються",
  "交易完成后，出现资金风险，被冻结或者涉嫌欺诈、传销、赌博的资金，我方将不在向买方放U，并给予退款":
    "Якщо після транзакції кошти будуть заморожені або підозрілі, ми не випустимо USDT і зробимо повернення коштів",
  "已付款，通知卖家": "Оплачено, повідомити продавця",
  "买方当日累计取消*笔订单，将会取消当日购买功能。确定取消该订单吗？":
    "Якщо ви скасуєте загалом * замовлень сьогодні, ваше право на покупку за сьогодні буде скасовано. Скасувати це замовлення?",
  添加收款方式: "Додати спосіб отримання",
  是否删除此收款方式: "Видалити цей спосіб отримання?",
  删除: "Видалити",
  请选择法币: "Виберіть фіатну валюту",
  机构名称: "Назва установи",
  请选择机构: "Виберіть установу",
  "当您出售数字货币时，您选择的收款方式将向买方展示，请确认填写无误。":
    "Вибраний вами спосіб отримання буде показаний покупцям, коли ви продаєте криптовалюту. Переконайтеся, що дані правильні.",
  请选择银行: "Виберіть банк",
  请输入姓名: "Введіть ім'я",
  账号: "Номер рахунку",
  请输入账号: "Введіть номер рахунку",
  收款码: "Код отримання",
  "银行账号/卡号": "Банківський рахунок/Номер картки",
  "请输入银行账号/卡号": "Введіть банківський рахунок/номер картки",
  "开户支行（选填）": "Відділення банку (необов'язково)",
  请输入开户支行: "Введіть відділення банку",
  "加入*官方频道": "Приєднуйтесь до офіційного каналу *",
  关于: "Про нас",
  条款: "Умови",
  成功: "Успішно",
  等待: "Очікування",
  作废: "Недійсний",
  确认付款: "Підтвердити оплату",
  "是否已完成付款？若确认付款后，商家将会在*分内进行确认是否收到付款。":
    "Оплату завершено? Після підтвердження продавець підтвердить отримання протягом * хвилин.",
  最大金额: "Максимальна сума",
  最小金额: "Мінімальна сума",
  付款: "Сплатити",
  法币充值: "Фіатне поповнення",
  法币提现: "Фіатне виведення",
  待支付: "Очікує оплати",
  已支付: "Сплачено",
  商户名: "Ім'я продавця",
  当前没有添加支付方式: "Не додано жодного способу оплати",
  添加后再出售: "Додайте один перед продажем",
  新人大礼包: "Пакет для новачків",
  注册即可领取: "Отримайте після реєстрації",
  立即领取: "Отримати зараз",
  不再提示: "Більше не показувати",
  "该奖励需在APP中领取，请下载APP":
    "Цю винагороду можна отримати лише в додатку. Завантажте додаток.",
  去交易: "Перейти до торгівлі",
  期权交易: "Торгівля опціонами",
  交易额: "Сума торгівлі",
  可用额度: "Доступний ліміт",
  交易周期: "Період торгівлі",
  看涨: "Бичачий (Call)",
  看跌: "Ведмежий (Put)",
  看空: "Шорт",
  当前持有: "Поточна позиція",
  胜率: "Відсоток успіху",
  "盈利/亏损数": "Кількість транзакцій з прибутком/збитком",
  累计实现盈亏: "Реалізований загальний прибуток/збиток",
  秒: "секунд",
  分: "хвилин",
  小时: "годин",
  周: "тиждень",
  下单时间: "Час замовлення",
  剩余时间: "Час, що залишився",
  买入价: "Ціна покупки",
  结算价: "Розрахункова ціна",
  实现盈利: "Реалізований прибуток",
  结算时间: "Час розрахунку",
  期权: "Опціон",
  新手教程: "Підручник для початківців",
  我的订单: "Мої замовлення",
  赔率: "Коефіцієнт",
  全部订单: "Усі замовлення",
  持有订单: "Відкриті замовлення",
  历史订单: "Історія замовлень",
  输入交易额度: "Введіть суму торгівлі",
  选择交易周期: "Виберіть період торгівлі",
  去注册: "Зареєструватися",
  冻结: "Заморозити",
  期权支出: "Витрата на опціон",
  期权收入: "Дохід від опціону",
  用户提现: "Виведення користувача",
  "是否购买？": "Купити цей опціон?",
  购买成功: "Покупка успішна",
  请签名: "Будь ласка, підпишіть",
  提交签名: "Надіслати підпис",
  清空签名: "Очистити підпис",
  签名审核中: "Підпис на перевірці",
  已提交: "Надіслано",
  扫一扫下载APP: "Відскануйте для завантаження додатку",
  新手领取大礼包: "Пакет для новачків",
  注册实名即送彩金: "Зареєструйтеся та підтвердіть особу, щоб отримати бонус",
  交易总额: "Загальний обсяг торгів",
  资产不足: "Недостатньо активів",
  "Win账户的资产不足，可从资金账户划转至此账户":
    "Недостатньо активів на WIN рахунку. Ви можете переказати активи зі свого основного рахунку.",
  Win: "WIN",
  比赛: "Змагання",
  未开始: "Не розпочалося",
  赛程: "Розклад",
  赛果: "Результат",
  已结束: "Завершено",
  让球: "Фора",
  进球数: "Голи",
  大: "Більше",
  小: "Менше",
  胜负平: "1X2 (Перемога/Нічия/Поразка)",
  和局: "Нічия",
  投注: "Ставка",
  下注金额: "Сума ставки",
  下注: "Зробити ставку",
  阵容: "Склад",
  分析: "Аналіз",
  输入下注金额: "Введіть суму ставки",
  下注成功: "Ставку зроблено успішно",
  投注记录: "Історія ставок",
  未结算: "Не розраховано",
  已结算: "Розраховано",
  流水: "Обіг",
  输赢: "Прибуток/Збиток",
  赛时: "Час матчу",
  下注时间: "Час ставки",
  足彩竞猜: "Футбольні прогнози",
  查看详情: "Переглянути деталі",
  输: "Програш",
  赢: "Виграш",
  主: "Вдома",
  客: "В гостях",
  主胜: "Перемога вдома",
  客胜: "Перемога в гостях",
  平: "Нічия",
  已延期: "Відкладено",
  账号异常: "Аномалія облікового запису",
  全场独赢: "Весь матч 1X2",
  全场让球: "Весь матч Фора",
  全场大小: "Весь матч Більше/Менше",
  总进球: "Загальна кількість голів",
  拍摄照片要求: "Вимоги до фотографії",
  标准拍摄: "Стандартне фото",
  边框缺失: "Відсутня рамка",
  照片模糊: "Розмите фото",
  闪光强烈: "Занадто сильний спалах",
  上传手持证件照: "Завантажити фото з документом у руці",
  上传证件照: "Завантажити фото документа",
  换一张: "Нове фото",
  出生日期: "Дата народження",
  请选择出生日期: "Виберіть дату народження",
  "输入下方正确的图形验证后，获取邮箱验证码进行注册":
    "Введіть код підтвердження нижче, щоб отримати код на електронну пошту для реєстрації.",
  "您还剩余*次认证次数，超出次数将无法继续认证":
    "У вас залишилося * спроб підтвердження. Після перевищення цього ліміту ви не зможете підтвердити себе.",
  上半场: "1-е тайм",
  下半场: "2-е тайм",
  独赢: "1X2",
  上半场独赢: "1-й тайм 1X2",
  下半场独赢: "2-й тайм 1X2",
  上半场让球: "1-й тайм Фора",
  下半场让球: "2-й тайм Фора",
  上半场大小球: "1-й тайм Більше/Менше",
  下半场大小球: "2-й тайм Більше/Менше",
  波胆: "Точний рахунок",
  上半场波胆: "1-й тайм Точний рахунок",
  下半场波胆: "2-й тайм Точний рахунок",
  单双: "Непарний/Парний",
  单: "Непарний",
  双: "Парний",
  上半场单双: "1-й тайм Непарний/Парний",
  下半场单双: "2-й тайм Непарний/Парний",
  上半场总进球: "1-й тайм Загальна кількість голів",
  下半场总进球: "2-й тайм Загальна кількість голів",
  中场: "Перерва",
  "注意：手持证件照请按照此示例图在白纸上书写文字并与证件一起拍摄":
    "Примітка: Для фото з документом у руці напишіть текст на білому аркуші паперу та сфотографуйте його разом із документом, як у прикладі.",
  "近期发现大量作弊账户，对一批违规账户进行了惩罚。如果有误判为违规账户，请联系在线客服。":
    "Нещодавно багато шахрайських облікових записів було покарано. Зв'яжіться зі службою підтримки, якщо вважаєте, що ваш обліковий запис покарано несправедливо.",
  最小下注金额: "Мінімальна ставка",
  参与活动最小下注金额: "Мінімальна ставка для участі в заході",
  记住密码: "Запам'ятати пароль",
  比分: "Рахунок",
  "您还未登录，请先登录": "Ви не увійшли в систему. Спочатку увійдіть.",
  立即登录: "Увійти зараз",
  下注限额: "Ліміт ставки",
  可赢金额: "Сума, яку можна виграти",
  闪兑详情: "Деталі швидкого обміну",
  大小球: "Більше/Менше",
  "由于汇率原因，下注金额和实际下注金额会有误差，请以订单为准。":
    "Через коливання валютного курсу остаточна сума ставки може відрізнятися. Замовлення є обов'язковим.",
  开赛时间: "Час початку",
  足球收入: "Дохід від футболу",
  足球支出: "Витрати на футбол",
  活动详情: "Деталі заходу",
  为世界杯喝彩: "Підтримайте чемпіонат світу",
  我的竞猜: "Мої прогнози",
  "竞猜比赛、有机会瓜分*USDT": "Прогнозуйте матчі та виграйте частину * USDT",
  "瓜分*USDT": "Розділіть * USDT",
  距离活动结束还有: "До кінця заходу залишилося:",
  我的门票: "Мої квитки",
  竞猜结束时间: "Кінець прогнозування",
  猜比分: "Прогнозувати рахунок",
  "福利派送中，完成任务即可获取门票":
    "Бонуси роздаються. Виконайте завдання, щоб отримати квитки.",
  "完成如下任务，可获对应数量门票的参与竞赛":
    "Виконайте наступні завдання, щоб отримати відповідну кількість квитків для участі в змаганні.",
  时: "година",
  活动: "Захід",
  竞猜记录: "Історія прогнозів",
  结果: "Результат",
  任务: "Завдання",
  去邀请: "Запросити",
  "每场比赛的比分竞猜，参与竞猜可瓜分$*美金的奖励。":
    "Прогнозуйте результат кожного матчу та виграйте частину $*.",
  "参与竞猜需要门票，门票可按照平台的任务进行获得。":
    "Для прогнозування потрібен квиток. Квитки можна отримати, виконуючи завдання платформи.",
  "竞猜成功后，把竞猜结果的截图发送给客服，客服会把奖金划入您的资金账户，你可以立即提取。":
    "Після успішного прогнозу надішліть знімок екрана в службу підтримки. Вони зарахують бонус на ваш рахунок, який ви зможете негайно вивести.",
  "禁止任何作弊行为、如果发现作弊行为，奖励无效。":
    "Шахрайство заборонено. Якщо його буде виявлено, винагороду буде скасовано.",
  "完成任务后，点击咨询客服获得门票。":
    "Після виконання завдань натисніть 'Зв'язатися зі службою підтримки', щоб отримати квитки.",
  继续猜: "Продовжити прогнозування",
  总单数: "Загальна кількість ставок",
  赛事筛选: "Фільтр за подією",
  球队筛选: "Фільтр за командою",
  总金额: "Загальна сума",
  总流水: "Загальний обіг",
  派奖金额: "Сума виплаченого бонусу",
  下注单数: "Кількість ставок",
  利润: "Прибуток",
  更多福利: "Більше бонусів",
  我的奖金: "Мій бонус",
  未认证: "Не підтверджено",
  总量: "Всього",
  或: "або",
  模拟交易: "Демо-торгівля",
  体验账户不可操作: "Недоступно на демо-рахунку",
  世界杯比分竞猜: "Прогнозування результатів ЧС",
  "领*USDT起": "Отримайте від * USDT",
  消息: "Повідомлення",
  滚球: "Live ставки",
  是: "Так",
  不是: "Ні",
  当前余额: "Поточний баланс",
  KOL招募: "Набір KOL",
  本月净输赢: "Чистий прибуток/збиток цього місяця",
  本月佣金: "Комісійні цього місяця",
  佣金比例: "Відсоток комісійних",
  活跃人数: "Активні користувачі",
  新增下级: "Нові нижчі рівні",
  登录人数: "Користувачі, які увійшли",
  首存人数: "Користувачі з першим поповненням",
  数据分析: "Аналіз даних",
  人数: "Кількість осіб",
  新注册存款金额: "Сума поповнень нових реєстрацій",
  老用户存款金额: "Сума поповнень існуючих користувачів",
  首存金额: "Сума першого поповнення",
  快捷入口: "Швидкий доступ",
  成员管理: "Управління учасниками",
  财务报表: "Фінансові звіти",
  分红报表: "Звіт про дивіденди",
  订单记录: "Історія замовлень",
  VIP专享: "VIP ексклюзив",
  推广工具: "Інструменти просування",
  计算规则: "Правила розрахунку",
  账变明细: "Деталі транзакції",
  成员: "Учасники",
  下级概览: "Огляд нижчих рівнів",
  下级成员总计: "Загалом нижчих рівнів",
  本月新增: "Нові цього місяця",
  本月活跃会员: "Активні учасники цього місяця",
  今日活跃会员: "Активні учасники сьогодні",
  本月有效活跃: "Ефективно активні цього місяця",
  活跃成员占比: "Частка активних учасників",
  本月活跃: "Активні цього місяця",
  今日活跃: "Активні сьогодні",
  下级成员: "Нижчі рівні",
  会员账号: "Обліковий запис учасника",
  统计时间: "Час статистики",
  筛选: "Фільтр",
  存款: "Поповнення",
  取款: "Виведення",
  总输赢: "Загальний прибуток/збиток",
  是否有效用户: "Активний користувач?",
  最近登录时间: "Останній вхід",
  否: "Ні",
  开始时间: "Час початку",
  结束时间: "Час завершення",
  提取: "Вивести",
  总盈亏: "Загальний результат",
  净盈亏: "Чистий результат",
  分红: "Дивіденд",
  概览: "Огляд",
  月度详细数据: "Детальні місячні дані",
  未发放: "Не видано",
  活跃用户: "Активні користувачі",
  有效新增会员: "Ефективні нові учасники",
  冲正后净输赢: "Чистий прибуток/збиток після коригування",
  上月结余: "Баланс попереднього місяця",
  净输赢: "Чистий прибуток/збиток",
  "系统每日新加坡时间1:00更新一次报表":
    "Звіти оновлюються щодня о 01:00 за сингапурським часом.",
  "报表中数据、总输赢、净输赢中正数表示代理方盈利、负数表示代理方亏损":
    "У звітах додатні числа означають прибуток для партнера, від'ємні числа означають збиток для партнера.",
  "佣金数据每天进行更新，仅供参考，并不做实际佣金派发标准":
    "Дані про комісійні оновлюються щодня, мають інформаційний характер і не є остаточною основою для виплати.",
  选择时间: "Вибір часу",
  足球: "Футбол",
  投注金额: "Сума ставки",
  有效订单: "Дійсні замовлення",
  下级账户: "Рахунок нижчого рівня",
  待成交: "В очікуванні",
  下单金额: "Сума замовлення",
  订单内容: "Вміст замовлення",
  秒数: "Секунди",
  联赛: "Ліга",
  队伍: "Команда",
  比赛时间: "Час матчу",
  玩法: "Тип ставки",
  等级规则表: "Таблиця правил рівнів",
  等级: "Рівень",
  活跃会员: "Активні учасники",
  最新活跃: "Остання активність",
  额外佣金: "Додаткові комісійні",
  "每月按照对应等级的增长标准与奖励制度执行，只可享受一个等级奖励。":
    "Щомісяця на основі стандартів зростання. Ви можете отримати вигоду лише від одного рівня.",
  渠道生成: "Генерація каналу",
  创建: "Створити",
  渠道名称: "Назва каналу",
  注册人数: "Кількість реєстрацій",
  浏览人数: "Кількість переглядів",
  构建状态: "Стан будівництва",
  禁用: "Вимкнути",
  启用: "Увімкнути",
  查看: "Переглянути",
  创建渠道: "Створити канал",
  创建成功: "Створення успішне",
  操作成功: "Дія успішна",
  渠道详情: "Деталі каналу",
  邀请码: "Код запрошення",
  访问人数: "Кількість відвідувачів",
  渠道地址: "Адреса каналу",
  我的福利: "Мої бонуси",
  充值福利: "Бонус за поповнення",
  当前流水: "Поточний обіг",
  如何参与: "Як взяти участь",
  币种充值: "Поповнення криптовалюти",
  充值福利中领取福利: "Отримати бонус у бонусі за поповнення",
  "规则：充值福利自愿领取，有效期为充值后的24小时内，过期无效，领取后将暂时锁定提现功能，当流水达到后即可解锁提现。":
    "Правило: Бонус за поповнення є добровільним, діє 24 години після поповнення. Після отримання виведення буде тимчасово заблоковано, доки не буде досягнуто вимоги щодо обігу.",
  失效日期: "Дата закінчення терміну дії",
  "暂无福利领取，充值后领取":
    "Немає доступного бонусу. Отримайте після поповнення.",
  参与: "Участь",
  充值赠送: "Бонус за поповнення",
  "领取*%的赠送": "Отримати *% бонусу",
  去领取: "Отримати",
  VIP奖励: "VIP винагорода",
  "当前可领取*USDT，是否确认领取":
    "* USDT доступно для отримання. Підтвердити?",
  "领取后将临时锁定提现功能，当您的流水到达*USDT后即可解除锁定":
    "Після отримання виведення буде тимчасово заблоковано, доки не буде досягнуто обігу в * USDT.",
  充值送大礼: "Подарунок за поповнення",
  "存入越多，送越多！": "Чим більше ви поповнюєте, тим більший подарунок!",
  无效: "Недійсний",
  有效: "Дійсний",
  总存金额: "Загальна сума поповнень",
  提示: "Примітка",
  "总输赢，净输赢中正数表示平台盈利，负数表示亏损，每天数据只做参考，并不做实际佣金派发标准。":
    "Додатні числа в загальному та чистому прибутку/збитку означають прибуток платформи. Щоденні дані є інформаційними.",
  "净盈亏：总盈亏-用户返水":
    "Чистий результат: Загальний результат - Повернення користувачеві",
  盈利方: "Сторона з прибутком",
  代理: "Агент",
  客户: "Клієнт",
  平局: "Нічия",
  平台: "Платформа",
  "已提交审核，请耐心等待": "Надіслано на перевірку. Будь ласка, зачекайте.",
  充值日期: "Дата поповнення",
  平台本月总输赢: "Загальний прибуток/збиток платформи цього місяця",
  KOL招募合作: "Співпраця з набору KOL",
  "平台现在开放【KOL招募活动】，只要您有社群媒体号，就可以和平台享受分红一次性推广客户，就可以享受终生收益。":
    "Платформа відкриває набір KOL. З обліковим записом у соціальних мережах ви можете отримувати дивіденди та довічний дохід через одноразове залучення клієнтів.",
  级别: "Рівень",
  平台利润返佣: "Комісійні від прибутку платформи",
  佣金案例: "Приклад комісійних",
  交易项目: "Торгові продукти",
  "期权交易、合约交易、足球游戏":
    "Торгівля опціонами, торгівля ф'ючерсами, футбольні ігри",
  报名方式: "Спосіб реєстрації",
  点击KOL招募报名: "Натисніть, щоб зареєструватися на набір KOL",
  "欢迎加入我们的团队，平台全面扶持您建立属于自己的用户体系，最高可得*的佣金，我们期待您加入。":
    "Ласкаво просимо до нашої команди. Ми підтримуємо вас у створенні власної користувацької системи. Отримуйте до *% комісійних. З нетерпінням чекаємо вашої участі.",
  输入联系方式: "Введіть контактні дані",
  最低活跃人数: "Мінімальна кількість активних користувачів",
  "如：本月活跃人数≥*并且本月平台总输赢≥*USDT，您属于等级*，即可得到*%的佣金。":
    "Наприклад: Якщо активні користувачі цього місяця ≥ * і загальний прибуток/збиток платформи ≥ * USDT, ви належите до рівня * і отримуєте *% комісійних.",
  比分竞猜: "Прогнозування рахунку",
  豪礼相赠: "Великий подарунок",
  足球活动: "Футбольний захід",
  圣诞节活动: "Різдвяний захід",
  "您参加了活动，临时锁定提现功能，还需*USDT流水就可以解除锁定。":
    "Ви взяли участь у заході. Виведення тимчасово заблоковано. Вам потрібно ще * USDT обігу для розблокування.",
  剩余流水: "Залишок обігу",
  助力足球: "Підтримайте футбол",
  佣金累计: "Загальні комісійні",
  有效投注: "Дійсні ставки",
  今日: "Сьогодні",
  今日返水: "Повернення сьогодні",
  VIP返水: "VIP повернення",
  返水记录: "Історія повернень",
  成员信息: "Інформація про учасника",
  基本信息: "Основна інформація",
  钱包余额: "Баланс гаманця",
  投注信息: "Інформація про ставку",
  返水: "Повернення",
  总下注: "Загальна ставка",
  今日输赢: "Прибуток/збиток сьогодні",
  下注动态: "Активність ставок",
  返水奖励: "Винагорода за повернення",
  分红金额: "Сума дивіденду",
  返水支出: "Витрата на повернення",
  总返水: "Загальне повернення",
  流水总额: "Загальний обіг",
  返水总额: "Загальне повернення",
  返水详情: "Деталі повернення",
  日流水: "Денний обіг",
  "平台根据你下级每日流水进行额外返水奖励,奖励每日新加坡时间00：00进行派发至赏金账户":
    "Платформа надає додаткове повернення на основі щоденного обігу ваших нижчих рівнів. Виплата щодня о 00:00 за сингапурським часом на бонусний рахунок.",
  "申请成功，等待审核": "Заявка успішна, очікує на перевірку",
  "我出本金，盈利共分享": "Я даю капітал, прибуток ділиться",
  最高分红: "Максимальний дивіденд",
  投资大师比赛: "Змагання Майстер-інвестор",
  "我出本金，你盈利": "Я даю капітал, ти заробляєш",
  共分享: "Спільне ділення",
  最高分红可得: "Максимально можливий дивіденд",
  "新用户专属福利来袭，免费赠送$*，领取后即可投资平台任何项目，盈利后立即可提取。":
    "Ексклюзивний вітальний бонус: $* безкоштовно. Після отримання ви можете інвестувати в будь-який проект. Прибуток можна негайно вивести.",
  报名领取: "Зареєструватися та отримати",
  审核驳回: "Перевірку відхилено",
  驳回原因: "Причина відхилення",
  活动运行周期: "Період проведення заходу",
  "申请成功后起至*天内完成超额收益。":
    "Досягніть надлишкового доходу протягом * днів після схвалення.",
  分红比: "Співвідношення дивіденду",
  "*日获得盈利后，可获得*%的收益额。":
    "Після отримання прибутку на день * ви отримуєте *% від суми доходу.",
  参与条件: "Умови участі",
  "俄罗斯、土耳其地区的用户，且未参与。":
    "Користувачі з Росії або Туреччини, які ще не брали участі.",
  计算项目: "Розраховані продукти",
  "合约、体育、期权": "Ф'ючерси, Спорт, Опціони",
  我的投资: "Мої інвестиції",
  参与天数: "Дні участі",
  累计下注: "Загальна ставка",
  累计盈亏: "Загальний прибуток/збиток",
  预计可分红: "Очікуваний дивіденд",
  常见问题: "Часті запитання (FAQ)",
  什么是平台出资: "Що таке фінансування платформи?",
  "平台根据部分国家的用户，免费提供资金让用户去投项目。":
    "Платформа надає безкоштовні кошти користувачам з певних країн для інвестування в проекти.",
  怎么获取平台出资的福利: "Як отримати бонус фінансування платформи?",
  "您是指定国家的用户即可，点击上方报名按钮，当平台审核完成后将会把*USDT转入当前账户下的赏金账户，您可划转至其他账户下进行投资。":
    "Якщо ви з однієї з визначених країн, натисніть кнопку реєстрації. Після схвалення * USDT буде переказано на ваш бонусний рахунок, який ви можете переказати для інвестування.",
  什么是分红: "Що таке дивіденд?",
  "分红指在规定时间内，收益额到达100%后，可分得超额收益的50%。例如：领取100USDT资金，收益额度是120%。":
    "Дивіденд: Якщо дохід досягає 100% протягом визначеного часу, ви отримуєте 50% надлишкового доходу. Приклад: Отримайте 100 USDT, досягніть 120% доходу, тоді 20% є надлишковим.",
  "如何取得分红？": "Як отримати дивіденд?",
  "活动周期每*天1次，活动结束后进行核算，满足活动要求后分红派发至赏金账户。若你未达到活动要求，系统将自动清除你的收益额和平台的出资。":
    "Цикл заходу відбувається кожні * днів. Після завершення проводиться розрахунок. Якщо ви виконуєте вимоги, дивіденд надсилається на бонусний рахунок. Якщо ні, ваш дохід і фінансування платформи будуть видалені.",
  "参与的账号需进行KYC认证，每个账户仅限一份福利。":
    "Облікові записи, що беруть участь, повинні бути підтверджені KYC. Лише один бонус на обліковий запис.",
  "参与账号的KYC需要指定的国家方可参与，其他地区无权限参与，请核对活动国家与您的国家是否一致。":
    "KYC для участі дійсний лише для визначених країн. Перевірте, чи ваша країна відповідає країні заходу.",
  "参与活动成功后，账户将临时锁定您的提现功能，当完成活动后即可解除您的提现功能。":
    "Після успішної участі виведення буде тимчасово заблоковано до завершення заходу.",
  "请遵守平台活动规则，若发现作弊、利用系统漏洞进行获利，平台将会长期冻结您的账户下所有资金。":
    "Дотримуйтесь правил заходу. У разі шахрайства або зловживання системними помилками всі кошти на вашому рахунку будуть назавжди заморожені.",
  平台出资: "Фінансування платформи",
  平台出资收回: "Фінансування платформи скасовано",
  投资大师奖励: "Винагорода Майстер-інвестор",
  请下载APP添加收款方式: "Завантажте додаток, щоб додати спосіб отримання",
  请下载APP进行身份验证: "Завантажте додаток для підтвердження особи",
  请下载APP参与: "Завантажте додаток для участі",
  技术指标: "Технічні індикатори",
  主图: "Основний графік",
  副图: "Додатковий графік",
  新注册人数: "Нові реєстрації",
  老用户存款人数: "Існуючі користувачі, які поповнюють",
  存款人数: "Кількість поповнень",
  取款人数: "Кількість виведень",
  投注人数: "Кількість ставок",
  "除印度尼西亚、印度、孟加拉国，且未参与过的用户。":
    "За винятком користувачів з Індонезії, Індії, Бангладеш, які ще не брали участі.",
  市场动态: "Динаміка ринку",
  外汇合约: "Форекс ф'ючерси",
  盈亏比: "Співвідношення прибутку/збитку",
  委托价: "Ціна замовлення",
  可用余额: "Доступний баланс",
  持仓额: "Вартість позиції",
  强平价: "Ціна ліквідації",
  修改: "Змінити",
  修改价位: "Змінити ціну",
  外汇: "Форекс",
  外汇账户: "Форекс рахунок",
  我的交易: "Мої транзакції",
  未设置: "Не встановлено",
  超出最大可设数值: "Перевищує максимальне встановлюване значення",
  超出最小可设数值: "Нижче мінімального встановлюваного значення",
  止盈超出最小可设数值:
    "Take-profit нижче мінімального встановлюваного значення",
  止损超出最大可设数值:
    "Stop-loss перевищує максимальне встановлюване значення",
  止盈超出最大可设数值:
    "Take-profit перевищує максимальне встановлюване значення",
  止损超出最小可设数值: "Stop-loss нижче мінімального встановлюваного значення",
  挖矿: "Майнінг",
  交易账户: "Торговий рахунок",
  买涨: "Купити (Лонг)",
  买跌: "Продати (Шорт)",
  请输入正确的银行卡信息: "Введіть правильні дані банківської картки",
  联系在线客服: "Зв'язатися з онлайн-підтримкою",
  法币交易请联系在线客服:
    "Зв'яжіться зі службою підтримки для фіатної торгівлі",
  提交订单: "Надіслати замовлення",
  "支付过程如有疑问,请联系在线客服":
    "Зв'яжіться зі службою підтримки, якщо у вас виникли запитання щодо процесу оплати",
  彩金赠送: "Надання бонусу",
  在线客服: "Онлайн-чат",
  最少投资: "Мінімальна інвестиція",
  "提交时间:": "Час надсилання:",
  提现拒绝: "Виведення відхилено",
  认证拒绝: "Підтвердження відхилено",
  认证通过: "Підтвердження схвалено",
  请输入正确的交易额度: "Введіть дійсну суму торгівлі",
  最大下注金额: "Максимальна ставка",
  手机号: "Номер телефону",
  邮箱注册: "Реєстрація за електронною поштою",
  手机号注册: "Реєстрація за номером телефону",
  查询: "Запит",
  手机号登录: "Вхід за номером телефону",
  邮箱登录: "Вхід за електронною поштою",
  请输入数量: "Введіть кількість",
  可用数量: "Доступна кількість",
  钱包登录: "Вхід через гаманець",
  请输入正确的邀请码: "Введіть дійсний код запрошення",
  "请输入邀请码(必填)": "Введіть код запрошення (обов'язково)",
  输入正确的金额: "Введіть дійсну суму",
  法币充值: "Фіатне поповнення",
  卢比充值: "Поповнення в індійських рупіях",
  请输入法币: "Введіть фіатну суму",
  请输入IFSC: "Введіть код IFSC",
  "银行编码(选填)": "Банківський код (необов'язково)",
  请输入银行编码: "Введіть банківський код",
  请输入大于8位数的密码: "Введіть пароль довжиною більше 8 символів",
  添加成功: "Додано успішно",
  "60秒": "60 секунд",
  "180秒": "180 секунд",
  "300秒": "300 секунд",
  "2次密码不一致": "Паролі не збігаються",
  输入提币数量: "Введіть кількість для виведення",
  图片格式不正确: "Неправильний формат зображення",
  图片大于20M: "Зображення перевищує 20 МБ",
  请设置委托价格: "Встановіть ціну замовлення",
  输入资金密码: "Введіть пароль активів",
  验证码错误: "Неправильний код підтвердження",
  充值拒绝: "Поповнення відхилено",
  请输入SSN: "Введіть SSN",
  结算完成: "Розрахунок завершено",
  继续下单: "Продовжити замовлення",
  限价: "Лімітне замовлення",
  买入价格: "Ціна покупки",
  买入量: "Кількість покупки",
  卖出价格: "Ціна продажу",
  卖出量: "Кількість продажу",
  买入: "Купити",
  卖出: "Продати",
  订单创建成功: "Замовлення створено успішно",
  币币买入支出: "Витрата на спот-купівлю",
  币币买入支出退还: "Повернення витрати на спот-купівлю",
  币币买入获得: "Отримано від спот-купівлі",
  币币卖出支出: "Витрата на спот-продаж",
  币币卖出支出退还: "Повернення витрати на спот-продаж",
  币币卖出获得: "Отримано від спот-продажу",
  币币交易手续费: "Комісія за спот-транзакцію",
  请输入限价: "Введіть лімітну ціну",
  成交: "Виконано",
  等待成交: "Очікує виконання",
  交易完成: "Транзакцію завершено",
  被取消: "Скасовано",
  交易时间: "Час транзакції",
  法币交易: "Фіатна транзакція",
  法币出售: "Фіатний продаж",

  两次密码不一致: "Паролі не збігаються",
  再次输入账户密码: "Введіть пароль облікового запису ще раз",

  美国: "Сполучені Штати",
  韩国: "Південна Корея",
  阿尔巴尼亚: "Албанія",
  津巴布韦: "Зімбабве",
  赞比亚: "Замбія",
  也门: "Ємен",
  美属维尔京群岛: "Американські Віргінські острови",
  英属处女群岛: "Британські Віргінські острови",
  越南: "В'єтнам",
  委内瑞拉: "Венесуела",
  瓦努阿图: "Вануату",
  乌兹别克斯坦: "Узбекистан",
  乌拉圭: "Уругвай",
  英国: "Велика Британія",
  阿拉伯联合酋长国: "Об'єднані Арабські Емірати",
  乌克兰: "Україна",
  乌干达: "Уганда",
  特克斯和凯科斯群岛: "Теркс і Кайкос",
  土库曼斯坦: "Туркменістан",
  土耳其: "Туреччина",
  突尼斯: "Туніс",
  特立尼达和多巴哥: "Тринідад і Тобаго",
  汤加: "Тонга",
  多哥: "Того",
  东帝汶: "Східний Тимор",
  泰国: "Таїланд",
  坦桑尼亚: "Танзанія",
  塔吉克斯坦: "Таджикистан",
  中国台湾: "Тайвань",
  叙利亚: "Сирія",
  瑞士: "Швейцарія",
  瑞典: "Швеція",
  斯威士兰: "Есватіні",
  苏里南: "Сурінам",
  苏丹: "Судан",
  斯里兰卡: "Шрі-Ланка",
  西班牙: "Іспанія",
  南非: "Південно-Африканська Республіка",
  索马里: "Сомалі",
  所罗门群岛: "Соломонові Острови",
  斯洛文尼亚: "Словенія",
  斯洛伐克: "Словаччина",
  "圣马丁岛（荷兰部分）": "Сінт-Мартен (голландська частина)",
  新加坡: "Сінгапур",
  塞拉利昂: "Сьєрра-Леоне",
  塞舌尔: "Сейшельські Острови",
  塞尔维亚: "Сербія",
  塞内加尔: "Сенегал",
  沙特阿拉伯: "Саудівська Аравія",
  圣多美和普林西比: "Сан-Томе і Принсіпі",
  圣马力诺: "Сан-Марино",
  萨摩亚: "Самоа",
  圣克里斯托弗和尼维斯: "Сент-Кіттс і Невіс",
  圣文森特和格林纳丁斯: "Сент-Вінсент і Гренадини",
  圣彼埃尔和密克隆岛: "Сен-П'єр і Мікелон",
  圣露西亚: "Сент-Люсія",
  圣基茨和尼维斯: "Сент-Кіттс і Невіс",
  卢旺达: "Руанда",
  俄罗斯: "Росія",
  罗马尼亚: "Румунія",
  留尼汪: "Реюньйон",
  刚果共和国: "Республіка Конго",
  卡塔尔: "Катар",
  波多黎各: "Пуерто-Ріко",
  葡萄牙: "Португалія",
  波兰: "Польща",
  菲律宾: "Філіппіни",
  秘鲁: "Перу",
  巴拉圭: "Парагвай",
  巴布亚新几内亚: "Папуа-Нова Гвінея",
  巴拿马: "Панама",
  巴勒斯坦: "Палестина",
  帕劳: "Палау",
  巴基斯坦: "Пакистан",
  阿曼: "Оман",
  挪威: "Норвегія",
  尼日利亚: "Нігерія",
  尼日尔: "Нігер",
  尼加拉瓜: "Нікарагуа",
  新西兰: "Нова Зеландія",
  新喀里多尼亚: "Нова Каледонія",
  荷属安德列斯群岛: "Нідерландські Антильські острови",
  荷兰: "Нідерланди",
  尼泊尔: "Непал",
  纳米比亚: "Намібія",
  缅甸: "М'янма",
  莫桑比克: "Мозамбік",
  摩洛哥: "Марокко",
  蒙特塞拉特岛: "Монтсеррат",
  黑山: "Чорногорія",
  蒙古: "Монголія",
  摩纳哥: "Монако",
  摩尔多瓦: "Молдова",
  墨西哥: "Мексико",
  马约特: "Майотта",
  毛里求斯: "Маврикій",
  毛里塔尼亚: "Мавританія",
  马里亚纳群岛: "Маріанські острови",
  马提尼克: "Мартиніка",
  马耳他: "Мальта",
  马里: "Малі",
  马尔代夫: "Мальдіви",
  马来西亚: "Малайзія",
  马拉维: "Малаві",
  马达加斯加: "Мадагаскар",
  马其顿: "Північна Македонія",
  中国澳门: "Макао",
  卢森堡: "Люксембург",
  立陶宛: "Литва",
  列支敦士登: "Ліхтенштейн",
  利比亚: "Лівія",
  利比里亚: "Ліберія",
  莱索托: "Лесото",
  黎巴嫩: "Ліван",
  拉脱维亚: "Латвія",
  老挝: "Лаос",
  吉尔吉斯斯坦: "Киргизстан",
  科威特: "Кувейт",
  基里巴斯: "Кірибаті",
  肯尼亚: "Кенія",
  哈萨克斯坦: "Казахстан",
  约旦: "Йорданія",
  日本: "Японія",
  牙买加: "Ямайка",
  象牙海岸: "Кот-д'Івуар",
  意大利: "Італія",
  以色列: "Ізраїль",
  爱尔兰: "Ірландія",
  伊拉克: "Ірак",
  伊朗: "Іран",
  印度尼西亚: "Індонезія",
  印度: "Індія",
  冰岛: "Ісландія",
  匈牙利: "Угорщина",
  中国香港: "Гонконг",
  洪都拉斯: "Гондурас",
  海地: "Гаїті",
  圭亚那: "Гайана",
  几内亚比绍共和国: "Гвінея-Бісау",
  几内亚: "Гвінея",
  危地马拉: "Гватемала",
  关岛: "Гуам",
  瓜德罗普岛: "Гваделупа",
  格林纳达: "Гренада",
  格陵兰岛: "Гренландія",
  希腊: "Греція",
  直布罗陀: "Гібралтар",
  加纳: "Гана",
  德国: "Німеччина",
  格鲁吉亚: "Грузія",
  冈比亚: "Гамбія",
  加蓬: "Габон",
  法属波利尼西亚: "Французька Полінезія",
  法属圭亚那: "Французька Гвіана",
  法国: "Франція",
  芬兰: "Фінляндія",
  斐济: "Фіджі",
  法罗群岛: "Фарерські острови",
  埃塞俄比亚: "Ефіопія",
  爱沙尼亚: "Естонія",
  厄立特里亚: "Еритрея",
  赤道几内亚: "Екваторіальна Гвінея",
  萨尔瓦多: "Сальвадор",
  埃及: "Єгипет",
  厄瓜多尔: "Еквадор",
  多米尼加共和国: "Домініканська Республіка",
  多米尼加: "Домініка",
  吉布提: "Джибуті",
  丹麦: "Данія",
  捷克: "Чехія",
  塞浦路斯: "Кіпр",
  库拉索: "Кюрасао",
  古巴: "Куба",
  克罗地亚: "Хорватія",
  哥斯达黎加: "Коста-Рика",
  科特迪瓦: "Кот-д'Івуар",
  库克群岛: "Острови Кука",
  科摩罗: "Коморські Острови",
  哥伦比亚: "Колумбія",
  智利: "Чилі",
  乍得: "Чад",
  中非共和国: "Центральноафриканська Республіка",
  佛得角: "Кабо-Верде",
  开曼群岛: "Кайманові Острови",
  开普: "Кейп",
  加拿大: "Канада",
  喀麦隆: "Камерун",
  柬埔寨: "Камбоджа",
  布隆迪: "Бурунді",
  布基纳法索: "Буркіна-Фасо",
  保加利亚: "Болгарія",
  文莱: "Бруней",
  巴西: "Бразилія",
  博茨瓦纳: "Ботсвана",
  波斯尼亚和黑塞哥维那: "Боснія і Герцеговина",
  玻利维亚: "Болівія",
  不丹: "Бутан",
  百慕大群岛: "Бермудські Острови",
  贝宁: "Бенін",
  伯利兹: "Беліз",
  比利时: "Бельгія",
  白俄罗斯: "Білорусь",
  巴巴多斯: "Барбадос",
  孟加拉国: "Бангладеш",
  巴林: "Бахрейн",
  巴哈马: "Багамські Острови",
  阿塞拜疆: "Азербайджан",
  奥地利: "Австрія",
  澳大利亚: "Австралія",
  阿鲁巴: "Аруба",
  亚美尼亚: "Вірменія",
  阿根廷: "Аргентина",
  安提瓜和巴布达: "Антигуа і Барбуда",
  安圭拉: "Ангілья",
  安哥拉: "Ангола",
  安道尔: "Андорра",
  美属萨摩亚: "Американське Самоа",
  阿尔及利亚: "Алжир",
  中国: "Китай",
  余额不足: "Недостатній баланс",
  最低购买: "Мінімальна покупка",
  最高购买: "Максимальна покупка",
  下单成功: "Замовлення успішно розміщено",
  平仓成功: "Позицію успішно закрито",
  请输入正确的平仓数量: "Введіть дійсну кількість для закриття",
  加仓成功: "Позицію успішно збільшено",
  请输入正确的加仓金额: "Введіть дійсну суму для збільшення позиції",
  收藏成功: "Додано до обраних",
  取消收藏成功: "Вилучено з обраних",
  加密币永续: "Перпетуал на криптовалюту",
  外汇永续: "Перпетуал на форекс",
  期权账户: "Рахунок опціонів",
  快捷卖币: "Швидкий продаж криптовалюти",

  托管资金: "Керовані кошти",
  托管中: "Під управлінням",
  预计日收益: "Орієнтовний денний дохід",
  累计收益: "Загальний дохід",
  周期: "Термін",
  日收益: "Денний дохід",
  限额: "Ліміт",
  立即托管: "Розпочати управління зараз",
  "已鎖定 請聯繫客服": "Заблоковано. Зв'яжіться зі службою підтримки.",
  产品列表: "Список продуктів",
  规则: "Правила",
  创建订单: "Створити замовлення",
  产品名称: "Назва продукту",
  托管周期: "Період управління",
  等级限制: "Обмеження за рівнем",
  托管金额: "Керована сума",
  限额: "Ліміт",
  余额: "Баланс",
  购买日: "Дата покупки",
  起息日: "Дата початку нарахування відсотків",
  派息时间: "Час виплати відсотків",
  每天: "Щодня",
  计息结束日: "Дата закінчення нарахування відсотків",
  每日收益: "Денний дохід",
  预计收益: "Орієнтовний дохід",
  "收益将自动发送至您的余额账户;":
    "Дохід автоматично надсилатиметься на баланс вашого рахунку;",
  "您的资金没有任何风险;": "Ваші кошти не піддаються жодному ризику;",
  "365*24小时不断地工作;": "Працює 24/7, 365 днів на рік;",
  托管中: "Під управлінням",
  结束: "Завершено",
  今日收益: "Сьогоднішній дохід",
  剩余周期: "Залишилося терміну",
  进行中: "Активний",
  已发放: "Виплачено",
  信誉分: "Бали репутації",

  复制成功: "Скопійовано успішно",
  VIP权益: "VIP-переваги",
  旧密码: "Старий пароль",
  请输入旧密码: "Введіть старий пароль",
  "忘记旧密码请联系客服重置。":
    "Якщо ви забули свій старий пароль, будь ласка, зверніться до служби підтримки, щоб скинути його.",
  去升级: "Оновити",
  描述: "Опис",
  实际存款金额: "Фактична сума депозиту",
  升级礼金: "Бонус за оновлення",
  隔夜利息: "Своп-відсотки (овернайт)",
  自动结算: "Автоматичний розрахунок",
  等级规则: "Правила рівнів",
  "WEB3.0币持有数据收益":
    "Прибутковість від даних про володіння монетами WEB3.0",
  总生产: "Загальне виробництво",
  有效节点: "Активні вузли",
  参与人: "Учасники",
  用户收益: "Прибутковість користувача",
  "流动性WEB3.0输出": "Вихід ліквідності WEB3.0",
  总资产: "Загальні активи",

  ETHAI持有数据收益: "Дохід від даних володіння ETHAI",
  AI量化流动性: "AI кількісна ліквідність",
  现货买入手续费: "Комісія за купівлю спот",
  现货支出: "Спот витрата",
  现货资金费率: "Спот ставка фінансування",
  现货卖出手续费: "Комісія за продаж спот",
  现货收入: "Спот дохід",
  外汇合约支出: "Витрата за валютним контрактом",
  外汇合约买入手续费: "Комісія за купівлю валютного контракту",
  外汇合约资金费率: "Ставка фінансування валютного контракту",
  外汇合约卖出手续费: "Комісія за продаж валютного контракту",
  外汇合约收入: "Дохід від валютного контракту",
  理财购买: "Купівля інвестиційного продукту",
  VIP理财日收益: "Щоденний дохід VIP інвестиційного продукту",
  VIP理财隔夜利息: "Відсоток за овернайт VIP інвестиційного продукту",
  VIP本金返还: "Повернення основного капіталу VIP",
  VIP彩金发放: "Виплата бонусу VIP",
  VIP彩金抵扣: "Відрахування бонусу VIP",
  隔夜利息: "Відсоток за овернайт",
  设置资产密码: "Встановити пароль активів",

  锁仓挖矿: "Заблокований майнінг",
  一站式理财服务: "Фінансовий сервіс в одному місці",
  产品: "Продукти",
  客服中心: "Центр підтримки клієнтів",
  贷款: "Позики",
  挖矿赚不停: "Безперервний заробіток на майнінгу",
  "锁仓挖矿是通过将USDT (USD:1USDT=1USD) 托管给平台超算力矿机，在平台矿池中进行挖矿收益。":
    "Заблокований майнінг означає, що USDT (USD:1USDT=1USD) розміщується в високопродуктивних майнінгових машинах платформи для отримання прибутку в майнінг-пулі платформи.",
  产品优势: "Переваги продукту",
  随存随取: "Поповнення та виведення у будь-який час",
  锁仓周期: "Період блокування",
  每日下发: "Щоденні виплати",
  随机空投: "Випадковий аірдроп",
  "100%资金安全保障": "100% гарантія безпеки коштів",
  "100%节假日收益不间断": "100% безперервний дохід навіть у святкові дні",
  成功锁仓后当天产出: "Дохід нараховується в день блокування",
  关于违约金: "Про штраф",
  "若您希望转出未到期的本金,则会产生违约金,违约金=违约结算比例*剩余天数*锁仓金额.":
    "Якщо ви хочете вивести капітал до завершення строку, стягується штраф. Штраф = ставка штрафу × залишкові дні × заблокована сума.",
  "举例:此锁仓挖矿的违约结算比例为5%,剩余3天到期,锁仓金额为10000U《USDT/USD》,则违约金=5%*3*10000=1500U,实际退回本金为15000U-1500U":
    "Приклад: ставка штрафу 5%, залишилось 3 дні, заблокована сума 10000U (USDT/USD). Штраф = 5%×3×10000=1500U, фактично повертається 15000U-1500U.",
  收益计算: "Розрахунок прибутку",
  "平台有多种锁仓挖矿理财产品供使用者选择,收益计算如下,举例:":
    "Платформа пропонує різні фінансові продукти заблокованого майнінгу. Розрахунок прибутку такий, наприклад:",
  "会员在平台锁仓10000U(USDT,USD),如选择了周期为7天,日产出为锁仓金额的0.7%~1.8%的理财产品,则每天产出如下":
    "Якщо користувач блокує 10000U (USDT, USD) і обирає 7-денний продукт із щоденним доходом 0,7%~1,8%, щоденний дохід такий:",
  "最低:10000Ux0.7%=70U;": "Мінімум: 10000U×0,7%=70U;",
  "最高:10000Ux1.8%=180U;": "Максимум: 10000U×1,8%=180U;",
  "即7天后可获得490U~1260U的收益,收益每日下发,锁仓本金到期后,自动转入您的资金账户.":
    "Через 7 днів можна отримати 490U~1260U доходу. Дохід виплачується щодня, а капітал автоматично повертається на рахунок після завершення строку.",
  正在托管的资金: "Кошти в управлінні",
  签到: "Щоденний вхід",
  锁仓订单: "Заблоковані ордери",
  预计今日收益: "Очікуваний дохід сьогодні",
  累计收益: "Загальний дохід",
  托管中的订单: "Ордери в управлінні",
  单笔最少: "Мінімальна сума",
  单笔最多: "Максимальна сума",
  日收益率: "Денна дохідність",
  说明: "Опис",
  "1.数据统计时间以GMT+8时间为准<br>2.每日收益值以GMT+8当天时间00:00-23:59点(本地时间00:00-23:59)的所有已结算订单为基准计算得出<br>3.当天的收益会统一在次日GMT+8时间00:00-00:10内派发.":
    "1. Дані розраховуються за часом GMT+8<br>2. Щоденний дохід базується на всіх закритих ордерах 00:00-23:59 GMT+8<br>3. Дохід виплачується наступного дня 00:00-00:10 GMT+8.",
  知道了: "Зрозуміло",
  锁仓: "Заблокувати",
  派息时间: "Час виплат",
  每日: "Щодня",
  托管资金: "Кошти під управлінням",
  到期返回: "Повернення після завершення",
  提前赎回: "Дострокове виведення",
  预计收益: "Очікуваний дохід",
  认购: "Підписка",
  热门: "Популярне",
  数字货币: "Криптовалюта",
  贵金属: "Дорогоцінні метали",
  大宗商品: "Сировинні товари",
  持仓明细: "Деталі позиції",
  历史明细: "Історія",
  当前价: "Поточна ціна",
  "↑买涨": "↑ Купити зростання",
  "↓买跌": "↓ Купити падіння",
  显示全部: "Показати все",
  买入金额: "Сума покупки",
  方向: "Напрям",
  收益: "Прибуток",
  预期收益: "Очікуваний прибуток",
  估用保证金: "Оцінена маржа",
  确认下单: "Підтвердити ордер",
  锁定: "Заблоковано",
  账户总资产: "Загальні активи рахунку",
  明细: "Деталі",
  今日收益: "Дохід сьогодні",
  仓位保证金: "Маржа позиції",
  持有仓位: "Відкриті позиції",
  "锁定金额=所有锁仓挖矿中未完成订单的金额总和":
    "Заблокована сума = сума всіх незавершених ордерів заблокованого майнінгу",
  "1.数据统计时间以GMT+8时间为准<br>2.每日收益值以GMT+8当天时间00:00-23:59点(本地时间00:00-23:59)的所有已结算订单为基准计算得出":
    "1. Дані базуються на GMT+8<br>2. Щоденний дохід розраховується з закритих ордерів",
  充值方式: "Спосіб поповнення",
  银行汇款: "Банківський переказ",
  "银行汇款请联系客服进行操作!":
    "Зверніться до підтримки для банківського переказу!",
  提款方式: "Спосіб виведення",
  "银行提款请联系客服进行操作!":
    "Зверніться до підтримки для банківського виведення!",
  资金明细: "Деталі коштів",
  提现记录: "Історія виведення",
  拒绝: "Відхилено",
  通过: "Схвалено",
  拒绝原因: "Причина відхилення",

  消息公告: "Оголошення",
  订单: "Замовлення",
  个人中心: "Особистий кабінет",
  "未到期赎回需支付一定的违约金!":
    "При достроковому погашенні необхідно сплатити штраф.",

  请输入区号: "Будь ласка, введіть код регіону",
  "请选择国家/地区": "Будь ласка, виберіть країну/регіон",

  今日开盘: "Сьогоднішнє відкриття",
  昨日收盘: "Вчорашнє закриття",

  实名认证即送: "Отримайте одразу після підтвердження особи",
  立即认证: "Підтвердити зараз",
  新用户礼包: "Подарунковий пакет для нових користувачів",
  完成新人任务领取: "Виконайте завдання для нових користувачів і отримайте",
  认证: "Підтвердити",
  时间周期: "Період часу",
  支付金额: "Сума платежу",
  已平仓: "Закрито",
  "MGBX 新用户欢迎礼包：每位用户最多可获得":
    "Вітальний пакет MGBX для нових користувачів: кожен користувач може отримати максимум",
  我已经阅读并同意: "Я прочитав(ла) і погоджуюся з",
  隐私政策: "Політика конфіденційності",

  放弃奖励离开: "Відмовитися від винагороди та вийти",
  继续注册: "Продовжити реєстрацію",
  分钟: "Хвилини",

  "请先勾选隐私政策!":
    "Будь ласка, спочатку ознайомтеся з Політикою конфіденційності!",

  添加其他到自选: "Додати інших до списку відстеження",

  充值最高可得: "Поповніть рахунок і отримайте до 30 000 доларів.",

  请输入格式正确的手机号:
    "Будь ласка, введіть дійсний номер мобільного телефону.",
  收起: "Collapse",
  上传截图: "Upload screenshot",
  "*充值成功后必须上传充值截图，否则将视为无效存款。": "*After a successful recharge, you must upload the recharge screenshot; otherwise the deposit will be invalid.",
};
// 乌克兰



// WEBPACK FOOTER //
// ./src/lang/wkl.js